import React from 'react';

import { BrandFooter } from '@redturtle/volto-io-studio/components/Layout';
import { FooterTop } from 'volto-editablefooter';

const FooterMainLeft = () => {
  return (
    <div className="footer-main-left">
      <BrandFooter />
      <FooterTop />
    </div>
  );
};

export default FooterMainLeft;
